<template>
  <v-snackbar
    :timeout="timeout"
    :top="!$vuetify.breakpoint.smAndDown"
    :bottom="$vuetify.breakpoint.smAndDown"
    absolute
    light
    :color="color"
    :value="isVisible"
    :vertical="hasAction"
    content-class="notification"
  >
    {{ message }}
    <div
      v-if="hasAction"
      class="action-button"
    >
      <v-btn
        outlined
        @click="() => {
          if (computedAction.onClick) computedAction.onClick(action);
          closeItem();
        }"
      >
        {{ actionText }}
      </v-btn>
    </div>
    <template #action>
      <slot />
      <v-btn
        v-if="!hideCloseButton"
        :icon="!hasAction"
        text
        small
        @click="closeItem"
      >
        <span v-if="hasAction">
          Close
        </span>
        <v-icon v-else>
          $vuetify.icons.clearIcon
        </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
import notificationActionMap from '../../../mixins/notification-action-map';
import variables from '../../../styles/_variables.scss';

export default {
  name: 'Notification',
  mixins: [notificationActionMap],
  props: {
    id: { type: Number, default: null },
    message: { type: String, default: '' },
    isError: { type: Boolean, default: false },
    action: { type: Object, default: null },
    timeout: { type: Number, default: 5000 },
    isVisible: { type: Boolean, default: false },
    hideCloseButton: { type: Boolean, default: false },
  },
  data() {
    return {
      timeoutId: null,
    };
  },
  computed: {
    color() {
      if (this.isError) return variables.errorLighter;
      return '';
    },
    hasAction() {
      return this.computedAction && !!this.computedAction.onClick;
    },
    computedAction() {
      if (this.action) {
        const action = this.notificationToActionMap[this.action.type];
        if (action) return action;
      }

      return this.action;
    },
    actionText() {
      if (!this.computedAction) return '';
      if (typeof this.computedAction.text === 'function') return this.computedAction.text(this.action);

      return this.computedAction.text || 'Action';
    },
    actionColor() { return variables.yellowDark; },
  },
  methods: {
    closeItem() {
      this.$emit('remove', this.id);
    },
  },
};
</script>
<style lang="scss">
.notification {
  text-align: center;
  width: 100%;
  .action-button {
    text-align: center;
    margin-top: 20px;
  }
}
// Ensure notifications appear above other content
// e.g. timeline markers, other overlays
.v-snack--absolute{
  z-index: 10000;
}
</style>
